"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_hash_1 = __importDefault(require("object-hash"));
var table = new WeakMap();
function hasher(args) {
    if (!args)
        return "";
    if (!args.length)
        return "";
    var key = "arg";
    for (var i = 0; i < args.length; ++i) {
        var _hash = void 0;
        if (typeof args[i] === "object") {
            if (!table.has(args[i])) {
                _hash = object_hash_1.default(args[i]);
                table.set(args[i], _hash);
            }
            else {
                _hash = table.get(args[i]);
            }
        }
        key += "@" + _hash;
    }
    return key;
}
exports.hasher = hasher;
//# sourceMappingURL=hasher.js.map